export const CALENDLY_LINK = 'https://calendly.com/ms--mxvq/30min';
